module.exports = __webpack_public_path__ + "img/Photo-I-Karavidas.effc4823.jpg";